//@flow
import {useRef, useEffect, useCallback} from 'react';

/**
 * Plays a notification sound from the given URL.
 * @param url Path to your sound file (e.g. '/sounds/notification.mp3')
 * @param enabled Whether sound is enabled (defaults to true)
 * @returns play() function to trigger the sound
 */
export function useNotificationSound(
  url: string,
  enabled: boolean = true
): () => void {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    const audio = new Audio(url);
    audio.volume = 0.25;
    audioRef.current = audio;
  }, [url]);

  const play = useCallback(() => {
    if (!enabled || !audioRef.current) return;
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(err => {
      console.error('Error playing notification sound:', err);
    });
  }, [enabled]);

  return play;
}
